module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "hero-body main-background"
  }, [_h('div', {
    staticClass: "container has-text-centered"
  }, [_h('div', {
    staticClass: "columns is-mobile"
  }, [_m(0), " ", _h('div', {
    staticClass: "column is-11-mobile is-two-thirds-tablet is-half-desktop"
  }, [_h('div', {
    staticClass: "collection-container"
  }, [_l((smallImages), function(image) {
    return _h('a', {
      staticClass: "image-container",
      on: {
        "click": function($event) {
          confirmRemoveImage(image)
        }
      }
    }, [_h('img', {
      staticClass: "image-display",
      attrs: {
        "src": image,
        "alt": ""
      }
    })])
  })])]), " ", _m(1)]), " ", _h('p', {
    staticClass: "instruction",
    domProps: {
      "innerHTML": _s(instructionMessage)
    }
  }), " ", _h('router-link', {
    staticClass: "button is-warning is-medium",
    attrs: {
      "to": "/"
    }
  }, ["Back"]), " ", (smallImages.length < maximumImage) ? _h('a', {
    staticClass: "button is-light is-medium file-upload"
  }, [_h('span', [_s(uploadButtonMessage)]), " ", _h('input', {
    attrs: {
      "type": "file",
      "id": "file_picker",
      "accept": "image/*"
    },
    on: {
      "change": uploadHandler
    }
  })]) : _e(), " ", (smallImages.length) ? _h('router-link', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "to": "/play-animation"
    }
  }, ["Create Mosaic"]) : _e()])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "column"
  })
}},function (){with(this) {
  return _h('div', {
    staticClass: "column"
  })
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4cc6baca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmallImages.vue
// module id = 125
// module chunks = 2